import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  step1: {
    name: "",
    events_type_id: null,
    country_id: "",
    city_id: null,
    latitude: "",
    longitude: "",
    phone: "",
    address: "",
  },

  step2: {
    short_summary: "",
    detailed_description: "",
    key_points: "",
    objectives: [],
  },

  step3: {
    // Common
    capacity: "",
    status: "InPerson", // "InPerson" | "OnLine"
    start_date: "",
    end_date: "",
    start_hour: "",
    end_hour: "",
    cutoff_time_booking_value: "",
    cutoff_time_booking_unit: "minutes",
    cancellation_policy_id: null,
    booking_confirmation_mode: "manual",
    price: "",

    // In-Person only
    details: "",

    // Online only
    platform: null,
    access_link: null,
  },
};


function deepUpdate(obj, field, value) {
  if (obj && typeof obj === "object") {
    if (field in obj) {
      obj[field] = value;
      return true;
    }
    for (const key of Object.keys(obj)) {
      if (deepUpdate(obj[key], field, value)) {
        return true;
      }
    }
  }
  return false;
}


const eventSlice = createSlice({
  name: "event",
  initialState,
  reducers: {
      updateEventStepField: (state, action) => {
      const { field, value } = action.payload;

      if (typeof field !== "string") {
        console.error("updateEventStepField: invalid field", field);
        return;
      }

      // Dot notation support
      if (field.includes(".")) {
        const keys = field.split(".");
        let target = state;
        for (let i = 0; i < keys.length - 1; i++) {
          if (!target[keys[i]]) return;
          target = target[keys[i]];
        }
        target[keys[keys.length - 1]] = value;
        return;
      }

      // Deep search fallback
      if (!deepUpdate(state, field, value)) {
        console.warn(`Field '${field}' not found in state`);
      }
    },

    updateStep1(state, action) {
      state.step1 = { ...state.step1, ...action.payload };
    },
    updateStep2(state, action) {
      state.step2 = { ...state.step2, ...action.payload };
    },
    updateStep3(state, action) {
      state.step3 = { ...state.step3, ...action.payload };
    },
    resetEventProduct(state) {
      state.step1 = initialState.step1;
      state.step2 = initialState.step2;
      state.step3 = initialState.step3;
    },
  },
});

export const { updateEventStepField, updateStep1, updateStep2, updateStep3, resetEventProduct } =
  eventSlice.actions;

export default eventSlice.reducer;
